import React from 'react';
import type { FC, ReactNode } from 'react';
import { useExit } from '@wix/cli-ui-kit';
import { AuthContext } from '../context.js';
import type { UserInfo } from '../schemas.js';
import { unifiedAuthStrategy } from '../auth-strategies/unified-auth-strategy.js';
import { EnsureLoggedIn } from '../components/EnsureLoggedIn.js';

interface Props {
  children: ReactNode;
  onError?: (error: unknown) => void;
  onLogin?: (userInfo: UserInfo) => void;
}

export const AuthProvider: FC<Props> = ({ children, onError, onLogin }) => {
  const exit = useExit();

  return (
    <EnsureLoggedIn
      authStrategy={unifiedAuthStrategy}
      onLogin={({ userInfo }) => onLogin?.(userInfo)}
      onError={onError ?? exit}
    >
      {({ getAccessToken, getRequestHeaders, userInfo }) => (
        <AuthContext.Provider
          value={{ getAccessToken, getRequestHeaders, userInfo }}
        >
          {children}
        </AuthContext.Provider>
      )}
    </EnsureLoggedIn>
  );
};
